import React, { useContext } from 'react';
import styles from '../farmFieldFlow.module.scss';
import { FormType } from 'enums/FieldTypeEnums';
import FieldsRow from 'shared/components/FieldsRow';
import COButton from 'shared/components/COButton';
import { ReactComponent as AddIcon } from 'assets/icons/add_enclosed.svg';
import {
  DynamicFields,
  LandChangeValue,
  STAGE_4,
} from 'constants/FarmboxConstants/stage4.constants';
import { GetLandChangeFields, getCommentField } from '../stage4FarmHelperData';
import { LandChanges, Stage4MetaData } from 'models/Farmbox/field.model';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { HelpDeskContext } from 'context/HelpDeskContext';
import HelpdeskService from 'services/HelpdeskService/Helpdesk.service';
import { useParams } from 'react-router-dom';
import isProductDisabled from 'shared/utils/isProductDisabled';
import clsx from 'clsx';

interface LandManagementChangeProps {
  landManagementMetaData: Stage4MetaData[];
  harvestYear?: number;
}

const LandManagementChangeSection = (props: LandManagementChangeProps) => {
  const { control, watch, resetField } = useFormContext();
  const { setHelpDeskData } = useContext(HelpDeskContext);
  const { fetchData } = HelpdeskService(setHelpDeskData);
  const { status } = useParams();
  const { landManagementMetaData, harvestYear } = props;
  const { REACT_HOOK_FORMS } = FormType;
  const { HEADING, LAND_CHANGES_LABELS } = STAGE_4;
  const { LAND_MANAGEMENT_CHANGE } = HEADING;
  const { ADD_LAND_MANAGEMENT } = LAND_CHANGES_LABELS;
  const isDisabled = isProductDisabled(status);

  const landManagementChangeLength = watch(
    'commodity.landManagementChanges'
  )?.length;
  const {
    fields: landManagementChangeFields,
    append: landManagementChangeAppend,
    remove: removeLandManagement,
  } = useFieldArray({
    control: control,
    name: DynamicFields.LAND_MANAGEMENT_DYNAMIC,
  });
  const handleAddLandManagementChange = () => {
    landManagementChangeAppend(new LandChanges());
  };

  return (
    <>
      <div className={styles.contentContainer}>
        <div className={styles.fieldHeaderContainer}>
          <h2 className={styles.headingContainer}>{LAND_MANAGEMENT_CHANGE}</h2>
          <div
            className={clsx(styles.addAction, {
              [styles.hideAction]: isDisabled,
            })}>
            <COButton text onClick={handleAddLandManagementChange}>
              <AddIcon />
              {ADD_LAND_MANAGEMENT}
            </COButton>
          </div>
        </div>
        <div className={styles.fieldRow}>
          <div className={styles.formFieldsContainer}>
            {landManagementChangeFields.map((land, index) => (
              <div key={land.id} className={styles.formFieldsContainer}>
                <FieldsRow
                  {...GetLandChangeFields({
                    remove: removeLandManagement,
                    index,
                    type: LandChangeValue.MANAGEMENT,
                    landManagementMetaData,
                    harvestYear,
                    landManagementChangeLength,
                    fetchData,
                    isDisabled,
                    resetField,
                  })}
                  formType={REACT_HOOK_FORMS}
                />
              </div>
            ))}
            <FieldsRow
              {...getCommentField({ fetchData, isDisabled })}
              formType={REACT_HOOK_FORMS}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LandManagementChangeSection;
